import React from 'react'
import { AuthProvider } from './AuthContext'
import { LoadingProvider } from './LoadingContext'

const Providers: React.FC<any> = ({ children }) => {
  return (
    <LoadingProvider>
      <AuthProvider>{children}</AuthProvider>
    </LoadingProvider>
  )
}

export default Providers
